import animation from '@helpers/animation';
import { imageUrl } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { useInView } from '@hooks/useInView';
import { ReactComponent as SvgArrowRight } from '@img/icons/arrow-right.svg';
import { getButtonTheme } from '@stories/Components/Buttons/Button/Button';
import DownloadButton from '@stories/Components/Buttons/DownloadButton/DownloadButton';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import TitleBlock from '@stories/Components/TitleBlock/TitleBlock';
import React from 'react';
import S from './InformationCard.styles';
const InformationCard = ({ id, cta, content, download, image, logo, layout = 'imageRight', size = 'wide', subtitle, themeOption = 'light', title, }) => {
    const [refContainer, isInView] = useInView({
        rootMargin: animation.inView.rootMargin,
    });
    return (React.createElement(S.Container, { ref: refContainer, id: id, isActive: isInView, flush: size === 'narrow' || size === 'viewport' ? 'both' : undefined, themeOption: themeOption, "data-layout": layout, "data-size": size, "data-theme": themeOption },
        React.createElement(S.Inner, null,
            React.createElement(S.ContentColumn, null,
                React.createElement(S.ContentWrapper, null,
                    logo && (React.createElement(S.Logo, { alt: logo.altText, draggable: false, loading: "lazy", src: imageUrl(logo, {}) })),
                    (subtitle || title) && (React.createElement(TitleBlock, { size: "small", title: title, subtitle: subtitle, isInView: isInView })),
                    content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }),
                    cta?.text && (React.createElement(S.CtaWrapper, null,
                        React.createElement(LinkButton, { href: cta.url, icon: SvgArrowRight, target: cta.target, themeOption: getButtonTheme(themeOption), title: cta.text, "aria-label": cta.accessibleText }))),
                    download?.text && (React.createElement(S.CtaWrapper, null,
                        React.createElement(DownloadButton, { ...download, themeOption: getButtonTheme(themeOption) }))))),
            React.createElement(S.ImageColumn, null,
                React.createElement("picture", null,
                    React.createElement(S.Image, { alt: "", loading: "lazy", role: "presentation", src: imageUrl(image, { width: 480 }), srcSet: getImageSrcSet(image), sizes: `${until(Device.Tablet)} 100vw, ${until(1710)} 50vw, 820px` }))))));
};
export default InformationCard;
function getImageSrcSet(image) {
    return [
        `${imageUrl(image, { width: 480 })} 480w`,
        `${imageUrl(image, { width: 768 })} 768w`,
        `${imageUrl(image, { width: 820 })} 820w`,
        `${imageUrl(image, { width: 960 })} 960w`,
        `${imageUrl(image, { width: 1440 })} 1440w`,
        `${imageUrl(image, { width: 1920 })} 1920w`,
    ].join(',');
}
